export default function useAnalytics() {
  const route = useRoute()
  const config = useRuntimeConfig()

  const trackEvent = event => {
    if (!import.meta.client || !window.dataLayer) return

    const utmParams = {}
    const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content']

    utmKeys.forEach(key => {
      if (route.query[key]) {
        utmParams[key] = route.query[key]
      }
    })

    if (!utmParams.utm_source || !utmParams.utm_medium) return

    const eventData = {
      event,
      page_path: route.fullPath,
      ...utmParams
    }

    //if (config.public.env === 'production') {
    window.dataLayer.push(eventData)
    //}
    console.log('Analytics:', event, eventData)
  }

  const trackApplyClick = () => trackEvent('pp_apply_button_click')
  const trackApplication = () => trackEvent('pp_application_submit')

  return {
    trackApplyClick,
    trackApplication
  }
}
